type FormValues = {
  bankAccountNumber: string | null;
  amount: string;
  [key: string]: any;
};

type FormErrors = {
  bankAccountNumber?: string[];
  amount?: string[];
  [key: string]: any;
};

export default function getDisabledCheck(values: FormValues, errors: FormErrors): boolean {
  let result = false;

  if (values.bankAccountNumber === null || errors?.bankAccountNumber?.length > 0) {
    result = true;
  }

  if (values.amount === '' || errors?.amount?.length > 0) {
    result = true;
  }

  return result;
}
